import React from 'react'
import "./DHoliday.css"
const DHoliday = () => {
  return (
    <div className='holiday'>
        <div>
            <p style={{color:"#00a6ed"}}>Holiday Easily</p>
            <h1>Book Tickets and Plan Your <br/> Holiday Easily</h1>
            <p>Discover a place taht suits your kind of trip. And Book Ticket and <br/> Enjoy on your own price. We will help you for that fun.</p>
        </div>
        <div className='holiday-element' style={{paddingTop:"30px"}} >
        <div className='onedown1'>
                <img style={{marginLeft:"80px",marginBottom:"10px"}} src="https://play-lh.googleusercontent.com/hGLHP_4FVvhnsNCt8Ht_qGVKbPpeZNKJ6s0hCxPTbk63-8OKwFWcIsPwOJ2VI_ZoTQ=w240-h480-rw" width={100}/>
                <h3>Easy to Buy Tickets</h3>
                <p>Set up your mood and Come with us.</p>
            </div>
            <div className='onedown'>
                <img style={{marginLeft:"80px",marginBottom:"10px"}}  src="https://res.cloudinary.com/practicaldev/image/fetch/s--sMubKV09--/c_limit%2Cf_auto%2Cfl_progressive%2Cq_auto%2Cw_880/https://thepracticaldev.s3.amazonaws.com/i/htvjgzk4yinimvem70ix.png" width={100}/>
                <h3>Best Tour Guide</h3>
                <p>Set up your mood and Come with us.</p>
            </div>
            <div className='onedown1'>
                <img style={{marginLeft:"80px",marginBottom:"10px"}}  src="https://scontent.fpat1-2.fna.fbcdn.net/v/t39.30808-6/327193146_886608229422847_5058810507441433613_n.jpg?_nc_cat=1&ccb=1-7&_nc_sid=be3454&_nc_ohc=gww_8A6MmgkAX_JjaCU&_nc_ht=scontent.fpat1-2.fna&oh=00_AfAbBgaUZi-mYLXaCkVYsgytHmrcmshWXZd0A25rjixjZw&oe=64DE12C0" width={100}/>
                <h3>Lot of Choices</h3>
                <p>Set up your mood and Come with us.</p>
            </div>
            <div className='onedown'>
                <img style={{marginLeft:"80px",marginBottom:"10px"}}  src="https://avatars.githubusercontent.com/u/38789170?s=200&v=4" width={100}/>
                <h3>Various Top Products</h3>
                <p>Set up your mood and Come with us.</p>
            </div>
        </div>
    </div>
  )
}

export default DHoliday